import { get } from '@navent-jobs/config'
import { Estadisticas, PeriodosEstadisticas } from '../store/dashboard/estadisticas/types'

const LOCAL_STORAGE_STATISTICS_PERIOD_KEY = 'dashboard-estadisticas-period'

class DashboardService {
  public getPostulaciones() {
    return get('/api-company/empresas/dashboard/postulaciones')
  }

  public getEstadisticas(): Promise<Estadisticas> {
    return get('/api-company/empresas/dashboard/estadisticas')
  }

  public getStoredStatisticsPeriod(): PeriodosEstadisticas | null {
    const localStorageValue = localStorage.getItem(LOCAL_STORAGE_STATISTICS_PERIOD_KEY)
    return localStorageValue ? PeriodosEstadisticas[localStorageValue] : null
  }

  public storeStatisticsPeriod(value: PeriodosEstadisticas) {
    localStorage.setItem(LOCAL_STORAGE_STATISTICS_PERIOD_KEY, value.toString())
  }

  public getContacto() {
    return get('/api-company/empresas/dashboard/contactoTelefonico')
  }
}

const dashboardService = new DashboardService()
export default dashboardService
